'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fp = require('lodash/fp');

exports.default = (0, _fp.curryN)(2, function () {
    var predicateArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var args = arguments[1];
    return predicateArray.reduce(function (passing, predicateFn) {
        return passing && predicateFn(args);
    }, true);
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/lib/predicates.js
// module id = 2294
// module chunks = 0